import * as React from "react";

const SliderTabLeft: React.FC = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 14C0 18.1463 0 25.7315 0 28C2.33333 28 10.4143 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C10.4143 0 2.33333 0 0 0C0 2.2685 0 9.85367 0 14Z" fill="white" fillOpacity="0.85"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M11.5 14L17.4639 19.9907C17.9947 20.5238 17.9312 21.4032 17.3293 21.8546C16.8358 22.2247 16.1449 22.175 15.7095 21.7379L8 14L15.7095 6.26207C16.1449 5.825 16.8358 5.77526 17.3293 6.14545C17.9312 6.59683 17.9947 7.47621 17.4639 8.00935L11.5 14Z" fill="#999999"/>
        </svg>
        
    );
};

export default React.memo(SliderTabLeft);
